module.exports = __webpack_public_path__ + "static/img/nosearch.ef70faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nosearch.png
// module id = HYGp
// module chunks = 1